import React, { Suspense, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { LoadingFallback } from "components/LoadingFallback";
import { AdminData } from "services/axios/role_admin/RoleAdminService";
import { useDialog } from "muibox";
import RoleAdminService from "services/axios/role_admin/RoleAdminService";
import { defaultAlertOptions } from "config/muibox";
import { mensajesGenerales } from "config/mensajes";
// import ClientesPage from "pages/clientes/ClientesPage";

interface AdminDataContext {
  adminData: AdminData | null;
  setAdminData: (adminData: AdminData) => void;
}

export const AdminDataContext = React.createContext<AdminDataContext | null>(null);

const DashboardPage = React.lazy(() => import('pages/dashboard/DashboardPage'));
const CronogramaPage = React.lazy(() => import('pages/cronograma/CronogramaPage'));
const CertificadosPage = React.lazy(() => import('pages/certificados/CertificadosPage'));
const EditarCertificadoPage = React.lazy(() => import('pages/certificados/EditarCertificadoPage'));

const EditarProductosHabilitadosPage = React.lazy(() => import('pages/configuracion/EditarProductosHabilitadosPage'));
// const CertificadoPDF = React.lazy(() => import('pages/certificados/CertificadoPDFPage'));
// const ObleasPage = React.lazy(() => import('pages/certificados/obleas/obleas'));
const ClientesPage = React.lazy(() => import('pages/clientes/ClientesPage'));
const EditarClientePage = React.lazy(() => import('pages/clientes/EditarClientePage'));
const UsuariosPage = React.lazy(() => import('pages/usuarios/UsuariosPage'));
const EditarUsuarioPage = React.lazy(() => import('pages/usuarios/EditarUsuarioPage'));
// const PerfilUsuarioPage = React.lazy(() => import('pages/usuarios/perfil-usuario'));
const OperadoresPage = React.lazy(() => import('pages/operadores/OperadoresPage'));
const EditarOperadorPage = React.lazy(() => import('pages/operadores/EditarOperadorPage'));
const NuevoServicioPage = React.lazy(() => import('pages/servicios/NuevoServicioPage'));
const EditarConfiguracionPage = React.lazy(() => import('pages/configuracion/EditarConfiguracionPage'));

const ProductosHabilitadosPage = React.lazy(() => import('pages/configuracion/ProductosHabilitadosPage'));
// const ServicioMapPage = React.lazy(() => import('pages/servicios/ServicioMapPage'));
// const HistorialServicioPage = React.lazy(() => import('pages/servicios/historial-servicios'));

// const MapsTest1 = React.lazy(() => import('pages/clientes/maps-test1'));
// const MapsTest2 = React.lazy(() => import('pages/clientes/maps-test2'));

// const UploadImage = React.lazy(() => import('pages/certificados/image-upload.jsx'));

const mensajes = {
  ...mensajesGenerales,
}

export default () => {
  const dialog = useDialog();
  const [adminData, setAdminData] = useState<AdminData | null>(null);
  const contextValue = { adminData, setAdminData }; //se usa esto para poder actualizarlo desde un child

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const _adminData = await RoleAdminService.fetchAdminData();
        setAdminData(_adminData);
      } catch (error) {
        error && //if not cancelled 
          dialog.alert({
            ...defaultAlertOptions,
            title: mensajes.formValidacion.haOcurridoUnError,
            message: `${error.message}`
          });
      }
    }
    fetchData();
  }, [dialog]);

  return (
    <Suspense fallback={<LoadingFallback />}>
      <AdminDataContext.Provider value={contextValue}>
        <Switch>
          <Route path="/admin" exact component={DashboardPage} />
          <Route path="/admin/dashboard" component={DashboardPage} />
          <Route path="/admin/cronograma" component={CronogramaPage} />

          <Route exact path="/admin/certificados" component={CertificadosPage} />
          <Route exact path="/admin/certificados/crear" component={EditarCertificadoPage} />
          <Route path="/admin/certificados/editar/:id" component={EditarCertificadoPage} />
          {/* <Route path="/admin/certificados/:id/pdf" component={CertificadoPDF} /> */}
          {/*<Route exact path="/admin/certificados/obleas" component={ObleasPage} />
        <Route exact path="/admin/certificados/obleas/:id" component={ObleasPage} />
        <Route exact path="/admin/certificados/uploadImage" component={UploadImage} />
        <Route exact path="/admin/certificados/:idCertificado" component={CertificadosPage} />
        */}

          <Route exact path="/admin/clientes" component={ClientesPage} />
          <Route path="/admin/clientes/editar/:id" component={EditarClientePage} />
          <Route path="/admin/clientes/crear" component={EditarClientePage} />

          {/* <Route path="/admin/maps/test1" component={MapsTest1} />
        <Route path="/admin/maps/test2" component={MapsTest2} /> */}

          <Route exact path="/admin/usuarios" component={UsuariosPage} />
          <Route path="/admin/usuarios/editar/:id" component={EditarUsuarioPage} />
          <Route path="/admin/usuarios/crear" component={EditarUsuarioPage} />
          {/*<Route path="/admin/usuario/perfil" component={PerfilUsuarioPage} /> */}
          <Route exact path="/admin/operadores" component={OperadoresPage} />
          <Route path="/admin/operadores/editar/:id" component={EditarOperadorPage} />
          <Route path="/admin/operadores/crear" component={EditarOperadorPage} />
          <Route path="/admin/servicios/crear" component={NuevoServicioPage} />
          <Route path="/admin/servicios/editar/:id" component={NuevoServicioPage} />
          {/* <Route path="/admin/servicios/map" component={ServicioMapPage} /> */}
          {/*<Route path="/admin/historial-servicios" component={HistorialServicioPage} /> */}
          <Route path="/admin/configuracion/editar" component={EditarConfiguracionPage} />
          <Route path="/admin/configuracion/productos/habilitados/editar" component={EditarProductosHabilitadosPage} />
          <Route path="/admin/configuracion/productos/habilitados" component={ProductosHabilitadosPage} />
        </Switch>
      </AdminDataContext.Provider>
    </Suspense>
  );
};
